import styled from 'styled-components';

export const FactorValidationWrapper = styled.div`
`

export const SubtitleOtpRequest = styled.div`
  margin-bottom: var(--spacing-regular);
  color: var(--color-text);
`;
